import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import verifyEmailAndPass from "../../Actions/loginAction";
import styles from "./login.module.css";
import { cx } from "../../Util/classHelpers";
import CustomInput from "./customInput";

const EMAIL_OR_PASS_MATCHED = "EMAIL_OR_PASS_MATCHED";

const AlertIcon = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 16.7308C12.2288 16.7308 12.4207 16.6533 12.5755 16.4985C12.7303 16.3437 12.8077 16.1518 12.8077 15.923C12.8077 15.6942 12.7303 15.5023 12.5755 15.3475C12.4207 15.1928 12.2288 15.1155 12 15.1155C11.7712 15.1155 11.5793 15.1928 11.4245 15.3475C11.2697 15.5023 11.1923 15.6942 11.1923 15.923C11.1923 16.1518 11.2697 16.3437 11.4245 16.4985C11.5793 16.6533 11.7712 16.7308 12 16.7308ZM12.0003 13.077C12.2129 13.077 12.391 13.0051 12.5345 12.8613C12.6782 12.7176 12.75 12.5395 12.75 12.327V7.827C12.75 7.6145 12.6781 7.43633 12.5343 7.2925C12.3904 7.14883 12.2122 7.077 11.9998 7.077C11.7871 7.077 11.609 7.14883 11.4655 7.2925C11.3218 7.43633 11.25 7.6145 11.25 7.827V12.327C11.25 12.5395 11.3219 12.7176 11.4658 12.8613C11.6096 13.0051 11.7878 13.077 12.0003 13.077ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill="#F97066"/>
      </svg>)
}

const LoginForm = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const loginRef = useRef(null);
    const history = useHistory();
    const passMatched = useSelector(state => state.passMatched);
    const dispatch = useDispatch();

    const formSubmitBtnClicked = (event) => {
        event.preventDefault();
        dispatch({type: EMAIL_OR_PASS_MATCHED, payload: null});
        loginRef.current.value = "Signing In";
        loginRef.current.disabled = true;
        dispatch(verifyEmailAndPass(email, password));
    }

    useEffect(() => {
        if (passMatched)
            history.push("/enterprise-portal");
        else if (passMatched === false) {
            loginRef.current.value = "Continue";
            loginRef.current.disabled = false;
            setTimeout(() => {
                dispatch({type: EMAIL_OR_PASS_MATCHED, payload: null});
            }, 10000);
        }
    }, [passMatched]);

    return (
        <div className={styles.loginFormRoot}>
            <div className={styles.loginFormHeaderSection}>
                <div className={styles.loginFormTitle}>Enterprise Dashboard</div>
                <div className={styles.loginFormSubtitle}>Sign in to your account</div>
            </div>
            <form className={styles.loginForm} onSubmit={formSubmitBtnClicked}>
                <div className={styles.inputsContainer}>
                    {passMatched === false && <div className={styles.loginError}>
                        <AlertIcon />
                        <div className={styles.loginErrorText}>
                            Incorrect email or password. Please try again.
                        </div>
                    </div>}
                    <CustomInput label="Email address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required={true} />
                    <CustomInput label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required={true} />
                </div>
                <div className={styles.buttonRow}>
                    <input
                        ref={loginRef}
                        type="submit"
                        className={styles.loginButton}
                        value="Continue"
                    />
                </div>
            </form>
        </div>
    );
}

export default LoginForm;
export {EMAIL_OR_PASS_MATCHED};
